import React from "react";
import "./thankyou.css";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";


export default function ThanksScreen() {
  const navigate = useNavigate();
  const { chargerId, connectorId } = useParams();

  return (
    <div className="thanks-root">

      <div className="thanks-card">

        {/* Glow Icon */}
        <div className="thanks-icon-wrap">
          <div className="thanks-icon">⚡</div>
        </div>

        {/* Title */}
        <h1 className="thanks-title">Charging Complete</h1>

        {/* Main Text */}
        <p className="thanks-main">
          Your session has been completed successfully.
        </p>

        {/* Sub Text */}
        <p className="thanks-sub">
          You can now unplug your vehicle and continue your journey safely.
        </p>

        {/* Divider */}
        <div className="thanks-divider"></div>

        {/* Button */}
        <button 
          className="thanks-btn"
          onClick={() => navigate(`/${chargerId}/${connectorId}`)}
        >
          Back to Home
        </button>

      </div>

    </div>
  );
}


